import { Drawer } from 'antd';
import styled from 'styled-components';

import { COLORS } from '@/shared/constants/colors';
import { Title as UiTitle } from '@/shared/uikit/Title';

export const StyledDrawer = styled(Drawer)`
  .ant-drawer-body {
    padding: 0 !important;
  }
`;

export const Container = styled.div`
  width: 100%;
  height: 100%;
  display: grid;
  grid-template-rows: 72px calc(100% - 72px - 92px) 92px;
  overflow: hidden;
`;

export const Header = styled.div`
  padding: 24px 24px 0;
  overflow: hidden;
  border-bottom: 1px solid ${COLORS.systemDark100};
`;

export const Body = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  overflow: scroll;
`;

export const Actions = styled.div`
  padding-inline: 24px;
  border-top: 1px solid ${COLORS.systemDark100};
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

export const Title = styled(UiTitle)`
  max-width: calc(100% - 32px);
  font-weight: 600;
  font-size: 22px;
  line-height: 24px;
`;

export const Info = styled.div`
  max-width: calc(600px - 48px);
  display: grid;
  grid-template-rows: 40px 1fr;
  grid-template-columns: 1fr minmax(0, 1fr);
  gap: 24px;

  & > * {
    overflow-wrap: break-word;
  }
`;

export const FileList = styled.div`
  margin-top: 8px;
`;
